/**
 * クロス商品設定マスタ管理画面 バイヤークロス商品設定一覧取得(リクエストパラメータ)用クラス
 *
 * @export BuyerCrossGoodsList
 * @class BuyerCrossGoodsList
 */
export class BuyerCrossGoodsList {
  /**  バイヤーコードリスト */
  public buyerCodeList: string[] = [];
  /** 媒体区分 */
  public mediumType: string = '';
}
